"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboBox = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../theme");
/**
 * A combobox component that provides an input field with a dropdown list of options.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/ComboBox.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-combobox--default}
 *
 * @example
 * ```tsx
 * <ComboBox menuTrigger="focus">
    <Label>Project</Label>
    <InputGroup>
      <UnstyledInput placeholder="Select a project" />
      <IconButton size="small">
        <ArrowDropDownIcon size={16} />
      </IconButton>
    </InputGroup>
    <RACPopover trigger="ComboBox">
      <ListBox>
        <ListBoxItem textValue="web-ui">web-ui</ListBoxItem>
        <ListBoxItem textValue="insights-service">insights-service</ListBoxItem>
        <ListBoxItem textValue="compass">compass</ListBoxItem>
        <ListBoxItem textValue="circle">circle</ListBoxItem>
      </ListBox>
    </RACPopover>
  </ComboBox>
 * ```
 *
 * @param children - The children of the component. Can be ReactNode or a render function
 * @param defaultFilter - The filter function used to determine if an option should be included in the list
 * @param formValue - Whether the text or key of the selected item is submitted as part of an HTML form
 * @param allowsEmptyCollection - Whether the combo box allows the menu to be open when the collection is empty
 * @param shouldFocusWrap - Whether keyboard navigation is circular
 * @param defaultItems - The list of ComboBox items (uncontrolled)
 * @param items - The list of ComboBox items (controlled)
 * @param inputValue - The value of the ComboBox input (controlled)
 * @param defaultInputValue - The default value of the ComboBox input (uncontrolled)
 * @param allowsCustomValue - Whether the ComboBox allows a non-item matching input value to be set
 * @param menuTrigger - The interaction required to display the ComboBox menu
 * @param disabledKeys - The item keys that are disabled
 * @param selectedKey - The currently selected key in the collection (controlled)
 * @param defaultSelectedKey - The initial selected key in the collection (uncontrolled)
 * @param isDisabled - Whether the input is disabled
 * @param isReadOnly - Whether the input can be selected but not changed by the user
 * @param isRequired - Whether user input is required on the input before form submission
 * @param isInvalid - Whether the input value is invalid
 * @param validate - A function that returns an error message if a given value is invalid
 * @param autoFocus - Whether the element should receive focus on render
 * @param name - The name of the input element, used when submitting an HTML form
 * @param validationBehavior - Whether to use native HTML form validation or ARIA
 * @param className - The CSS className for the element. Can be string or a function
 * @param style - The CSS styles for the element. Can be CSSProperties or a function
 * @param onOpenChange - Method that is called when the open state of the menu changes
 * @param onSelectionChange - Handler that is called when the selection changes
 * @param onInputChange - Handler that is called when the ComboBox input value changes
 * @param onFocus - Handler that is called when the element receives focus
 * @param onBlur - Handler that is called when the element loses focus
 * @param onFocusChange - Handler that is called when the element's focus status changes
 * @param onKeyDown - Handler that is called when a key is pressed
 * @param onKeyUp - Handler that is called when a key is released
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.ComboBox = (0, styled_1.default)(react_aria_components_1.ComboBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), theme_1.theme.space.space8);
var templateObject_1;
//# sourceMappingURL=ComboBox.js.map